import React, { useEffect, useState } from 'react';
import { collection, addDoc, doc, getDoc,} from 'firebase/firestore';
import { auth, db } from '../../Firebase/firebase';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { useMediaQuery, useTheme, Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import Tooltip from '@mui/material/Tooltip';
//import { useAuth } from '../AuthContext';
import { useAuth } from '../../contexts/AuthContext';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from 'react-router-dom';
import { useActiveComponent } from '../ActiveComponentContext.js';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { fontWeight } from '@mui/system';

const SummaryCard = ({
  id, //this is user ID not post ID!!!!
  postID, //this is the actual post ID
  image,
  title,
  summary,
  images,
  photoURL,
  username,
  name,
  email,
  date,
  category,
  country,
  onClick,
  vertical = '185px',
  horizontal = '310px',
}) => {
  const {
    currentUser,
    setShowAlertDialog,
    setIsBookmarkForAlert,
    bookmarks, // Provide the bookmarks state
    toggleBookmark, // Provide the toggleBookmark function
  } = useAuth();
  const { setActivePath } = useActiveComponent();

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  // const [recoveredUsername, setRecoveredUsername] =useState("")
  const open = Boolean(anchorEl);

  const isBookmarked = bookmarks[postID] || false;
  //console.log(postID); //doesn't include" userId" as prefix_ "userId_postID", just postID alone

  // // let missingUsername
  // const getMissingUsername = async () =>{
  //   if (!username) {
  //     try {
  //       // Fetch username from userData using userId
        
  //       const userDoc = await getDoc(doc(db, "users", id));
  //       if (userDoc.exists()) {
  //         const userData = userDoc.data();
  //         // missingUsername = userData.username
  //         // console.log(missingUsername)
  //         return userData.username
  //         // path = `/${userData.username}`; // Use the fetched username
  //       }
  //     } catch (error) {
  //       console.error("Error fetching username:", error);
  //       return;
  //     }
  //   }
    
  // }

  // useEffect(() => {
  //   const fetchUsername = async () => {
  //     const foundUsername = await getMissingUsername(); // Wait for async function to complete
  //     setRecoveredUsername(foundUsername); // Update state with retrieved username
  //   };
  //   fetchUsername();
  // }, [id]); // Ensure `id` is available when useEffect runs
  
  // console.log(recoveredUsername);




  // const recoveredUsername = getMissingUsername()
  // console.log(recoveredUsername)

  // console.log("user's username is:", username)

  const showPostInfo = () => {
    onClick();
    handleClose();
  };
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCategoryClick = (category) => {
    const path = generatePath(category);
    setActivePath(path); // Update the active path
    navigate(path);
  };
  const handleCopyLink = (platform) => {
    const postUrl = `${window.location.origin}/posts/${postID}`;
    //let shareUrl = '';
    //const shareText = `${title}\n\n${summary}\n\n${postUrl}`; // Including title, summary, and URL
    navigator.clipboard.writeText(postUrl);
    alert('Link copied to clipboard!');
  };

  //Handle navigation to username page, when it's clicked
  // const handleUsernameClick = (path) => {
  //   navigate(path);
  //   setActivePath(path);
  // };

  const handleUsernameClick = async (path, userId) => {
    // if (!path) {
    //   try {
    //     // Fetch username from userData using userId
    //     const userDoc = await getDoc(doc(db, "users", userId));
    //     if (userDoc.exists()) {
    //       const userData = userDoc.data();
    //       console.log("clicked username", userData.username )
    //       path = `/${userData.username}`; // Use the fetched username
    //     }
    //   } catch (error) {
    //     console.error("Error fetching username:", error);
    //     return;
    //   }
    // }
    if (path) {
      // navigate(path);
      navigate(`/users/${userId}`);
      setActivePath(`/users/${userId}`);
      //console.log("i clicked the recoveredname for path", `/users/${userId}`)
      //router.push(path); // Navigate to the user's posts
    }
    if(!path){
      navigate(`/users/${userId}`)
      setActivePath(`/users/${userId}`);
      //console.log("i clicked the recoveredname", `/users/${userId}`)
    }
  }

  //used to Handle Bookmark, with isBookmarked stored in context:
  const handleBookmarkClick = () => {
    if (!currentUser) {
      setShowAlertDialog(true);
      setIsBookmarkForAlert(true);
      return;
    }

    toggleBookmark(postID, {
      creatorsUserId: id,
      title,
      summary,
      images,
      photoURL,
      username,
      //name,
      email,
      date,
      category,
      country: country || null,//country was causing issues - check with other toggleBookmarks
      //city:city || null
    });
  };

  // Set SummaryCard height based on screen size
  const height = isMdUp && isLgUp ? vertical : '200px'; // You can adjust 'auto' for other sizes if needed
  const cardWidth = isMdUp && isLgUp ? horizontal : '310px';

  return (
    <Card
      sx={{
        p: 1.6,
        borderRadius: 4,
        width: cardWidth,
        height: {
          xs: '225px',
          sm: '225px',
          md: '250px',
          lg: '250px',
          xl: '250px',
        },
        maxHeight: {
          xs: '225px',
          sm: '225px',
          md: '250px',
          lg: '250px',
          xl: '250px',
        },
        '&:hover': {
          boxShadow: '0px 4px 20px rgba(0, 0, 50, 0.2)', // Custom hover effect
          transform: 'scale(1.02)', // Optional: adds a slight zoom effect
          transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
          backgroundColor: 'ghostwhite',
        },
      }}
    >
      {/* Disabled CardActionArea - it was causing React nested button issues */}
      <Box sx={{ position: 'relative' }}>
        {image ? (
          <CardMedia
            component='img'
            // height={height}
            image={image}
            alt='post image'
            sx={{
              objectFit: 'cover', // Ensures the image covers the area
              width: cardWidth, // Ensures the image fills the width of the card
              //height: height, // Matches the height set earlier
              borderRadius: 4,
              height: {
                xs: '165px',
                sm: '165px',
                md: '180px',
                lg: height,
                xl: height,
              },
            }}
             onClick={onClick}
            //onClick={showPostInfo}
          />
        ) : (
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{
              //border:'2px solid red',
              color: 'white',
              backgroundColor: 'black',
              display: 'flex',
              textAlign: 'flex-start',
              borderRadius: '12px',
              boxShadow: '1px 1px 3px grey',
              height: {
                xs: '140px',
                sm: '150px',
                md: '150px',
                lg: '150px',
                xl: '150px',
              },
              maxHeight: {
                xs: '140px',
                sm: '150px',
                md: '150px',
                lg: '150px',
                xl: '150px',
              },
              overflowY: 'auto',
              fontFamily: 'Montserrat',
              p: { xs: 1.5, sm: 0.5, md: 1, lg: 2, xl: 1 },
              m: 0,
              ml: 0,
              mr: 0,
              mt: { xs: 0.2, sm: 0.2, md: 0.2, lg: 0.5, xl: 0.5 },
              mb: 0,
              fontSize: { xs: 12, sm: 11, md: 12, lg: 12, xl: 12 },
              whiteSpace: 'pre-line', // This will preserve line breaks and spaces
              '&:hover': {
                //boxShadow: '0px 1px 2px inset grey',
                borderRadius: 2,
                cursor: 'grab',
              },
              '&::-webkit-scrollbar': {
                width: '8px', // Width of the scrollbar
                backgroundColor: 'transparent', // Hide scrollbar background by default
              },
              '&:hover::-webkit-scrollbar': {
                backgroundColor: '#e0e0e0', // Show the scrollbar on hover
              },
              '&:hover::-webkit-scrollbar-thumb': {
                backgroundColor: '#888', // Show the scrollbar on hover
                borderRadius: '10px', // Round the corners of the scrollbar thumb
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555', // Darker color when hovered over the scrollbar thumb
              },
            }}
          >
            {summary}
          </Typography>
        )}

        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            width: '95%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 0.5,
          }}
        >
          <Typography
            variant='body'
            color={image ? 'black' : 'black'}
            sx={{
              backgroundColor: image ? 'white' : 'white',
              pl: 1,
              pr: 1,
              pt: 0.3,
              pb: 0.3,
              fontSize: { xs: 9, sm: 9, md: 9, lg: 10, xl: 10 },
              borderRadius: 3,
              ml: 1,
              cursor: 'pointer',
              fontFamily: 'Montserrat',
            }}
            onClick={() => handleCategoryClick(category)} // Handle category click
          >
            {category}
          </Typography>

          <IconButton disableRipple onClick={handleMenuClick}>
            <MoreHorizIcon
              sx={{
                color: image ? 'black' : 'black',
                backgroundColor: image ? 'white' : 'white',
                p: 0.4,
                fontSize: 14,
                borderRadius: '50%',
                mr: { xs: 0, sm: 0, md: 0.1, lg: 0, xl: 0 },
              }}
            />
          </IconButton>
          <Menu
            sx={{ borderRadius: 10 }}
            id='basic-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem
              sx={{
                pt: 0,
                pb: 0,
                fontSize: { xs: 11, sm: 11, md: 11, lg: 12, xl: 12 },
                fontFamily: 'Montserrat',
              }}
              onClick={showPostInfo}
            >
              Detailed View
            </MenuItem>
          </Menu>
        </Box>
      </Box>

      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 1,
        }}
      >
        <Typography
          gutterBottom
          variant='h6'
          component='div'
          sx={{
            display: 'flex',
            textAlign: 'flex-start',
            maxHeight: '19px',
            width: '100%',
            overflowY: 'auto',
            cursor: 'pointer',
            fontFamily: 'Montserrat',
            fontWeight: '600',
            fontSize: { xs: 10, sm: 10, md: 11, lg: 12, xl: 12 },
            mb: 0,
            mt: 0,
            m: 0,
            p: 0.2,
            '&:hover': { borderRadius: 2 },
            '&::-webkit-scrollbar': {
              width: '8px', // Width of the scrollbar
              backgroundColor: 'transparent', // Hide scrollbar background by default
            },
            '&:hover::-webkit-scrollbar': {
              backgroundColor: '#e0e0e0', // Show the scrollbar on hover
            },
            '&:hover::-webkit-scrollbar-thumb': {
              backgroundColor: '#888', // Show the scrollbar on hover
              borderRadius: '10px', // Round the corners of the scrollbar thumb
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555', // Darker color when hovered over the scrollbar thumb
            },
          }}
        >
          {title}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            p: 0,
          }}
        >
          <Typography
            // onClick={() => handleUsernameClick(`/${username}`)}
            onClick={() => handleUsernameClick(username ? `/${username}`:null, id)}
            variant='body1'
            color='text.secondary'
            sx={{
              fontFamily: 'Montserrat',
              mt: 0,
              fontSize: { xs: 10, sm: 10, md: 11, lg: 12, xl: 12 },
              '&:hover': {
                cursor: 'pointer',
                textShadow: '0px 0px 0.5px black',
              },
            }}
          >
            {photoURL && (
              <IconButton
                disableRipple
                sx={{
                  p: 0,
                }}
              >
                <Avatar
                  alt={name || 'User'}
                  src={photoURL || null}
                  sx={{
                    width: { xs: 22, sm: 22, md: 22, lg: 24, xl: 24 },
                    height: { xs: 22, sm: 22, md: 22, lg: 24, xl: 24 },
                    mr: 0.5,
                    ml: 0.5,
                    mb: 0.2,
                    fontSize: { xs: 9, sm: 9, md: 10, lg: 11, xl: 11 },
                    bgcolor: photoURL ? 'crimson' : 'violet',
                    '&:hover': {
                      cursor: 'pointer',
                      boxShadow: '0px 0px 4px black',
                    },
                  }}
                >
                  {!photoURL && (name?.[0] || email?.[0] || 'U')}
                </Avatar>
              </IconButton>
            )}
            {username }
          </Typography>
          <Tooltip title={isBookmarked ? 'Unsave Post' : 'Save Post'}>
            <IconButton disableRipple onClick={() => handleBookmarkClick()}>
              {isBookmarked ? (
                <BookmarkIcon
                  sx={{
                    fontSize: {
                      xs: 20,
                      sm: 20,
                      md: 21,
                      lg: 22,
                      xl: 22,
                    },
                    mt: 0,
                    color: 'crimson',
                  }}
                />
              ) : (
                <BookmarkBorderIcon
                  sx={{
                    fontSize: {
                      xs: 21,
                      sm: 21,
                      md: 21,
                      lg: 22,
                      xl: 22,
                    },
                    mt: 0,
                    color: 'crimson',
                    '&:hover': {
                      transform: 'scale(1.11)', // Optional: adds a slight zoom effect
                      transition:
                        'transform 0.5s ease-in-out, box-shadow 0.3s ease-in-out',
                    },
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
